import React from 'react';
import { Link } from 'react-router-dom';

const MenuItems = ({ parentMenu, secondParentMenu, activeMenu }) => {
  return (
    <ul className="main-menu__list">
       <li className={parentMenu === 'Contact' ? 'current-menu-item' : ''}>
        <Link to="/" className={activeMenu === '/' ? 'active-menu' : ''}>
          Home
        </Link>
      </li>
    
       <li >
        <Link to="/event" className={activeMenu === '/event' ? 'active-menu' : ''}>
          Event
        </Link>
      </li>
      <li >
        <Link to="/promo-codes" className={activeMenu === '/promo-codes' ? 'active-menu' : ''}>
          Promo Codes
        </Link>
      </li>
       <li>
        <Link to="/event-news" className={activeMenu === '/event-news' ? 'active-menu' : ''}>
          Event News
        </Link>
      </li>
       <li >
        <Link to="/about" className={activeMenu === '/about' ? 'active-menu' : ''}>
          About
        </Link>
      </li>
     
  
      <li >
        <Link to="/contact" className={activeMenu === '/contact' ? 'active-menu' : ''}>
          Contact
        </Link>
      </li>
    </ul>
  );
};

export default MenuItems;
